<template>
  <v-tooltip v-if="allowed" bottom>
    <template #activator="{ on, attrs }">
      <v-btn icon small v-bind="attrs" :aria-label="$t('audit-trail.title')" v-on="on" @click="show">
        <v-icon small>mdi-history</v-icon>
      </v-btn>
    </template>
    {{ $t('audit-trail.title') }}
  </v-tooltip>
</template>

<script>
import { EventBus } from '@includes/EventBus'

/**
 * L'icône d'historique, partout la même, en haut à droite de l'écran d'information et d'édition : sur une fiche (`entity-type`, `entity-id`), tout l'objet ; sur un formulaire,
 * en plus `:fields`, seulement ses champs, ou `:action-prefixes`, seulement ces actions ; sur un module (`module`, ou `entity-type` et `organization-id`), tous ses
 * objets. Elle ouvre le panneau unique (`AuditTrailPanel`), dans le périmètre de la personne (le serveur l'applique).
 * Visible avec le droit de relire l'historique.
 *
 * Dans un panneau latéral : `input` dit si l'historique est ouvert (le panneau reste alors ouvert), `close()` le ferme
 * avec lui.
 *
 *   <audit-trail-button entity-type="Organization" :entity-id="organization.id" :fields="['iban', 'bic']" />
 */
export default {
  name: 'AuditTrailButton',

  props: {
    entityType: { type: String, default: null },
    entityId: { type: String, default: null },
    module: { type: String, default: null },
    organizationId: { type: String, default: null },
    fields: { type: Array, default: () => [] },
    actionPrefixes: { type: Array, default: () => [] },
  },

  data() {
    return { opened: false, subscription: null }
  },

  computed: {
    allowed() {
      return (this.currentUser?.permissions || []).includes('AUDIT_VIEW')
    },
  },

  created() {
    this.subscription = EventBus.$on('audit-trail:closed', () => {
      if (this.opened) {
        this.opened = false
        this.$emit('input', false)
      }
    })
  },

  beforeDestroy() {
    EventBus.$off(null, this.subscription)
  },

  methods: {
    show() {
      this.opened = true
      this.$emit('input', true)
      EventBus.$emit('audit-trail:open', { entityType: this.entityType, entityId: this.entityId, module: this.module, organizationId: this.organizationId, fields: this.fields, actionPrefixes: this.actionPrefixes })
    },
    close() {
      if (this.opened) {
        EventBus.$emit('audit-trail:close')
      }
    },
  },
}
</script>
